import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "processWorksheetForm" } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-end" },
        [
          _c(
            VBtn,
            {
              attrs: { text: "" },
              on: {
                click: function ($event) {
                  return _vm.toggleStatus()
                },
              },
            },
            [_vm._v(_vm._s(_vm.processWorksheet.status))]
          ),
        ],
        1
      ),
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column justify-space-between" },
                [
                  _vm.worksheetTypeFields.hasProcessType
                    ? _c(VSelect, {
                        staticClass: "mx-2",
                        attrs: {
                          items: _vm.processTypes,
                          label: "Process Type",
                          multiple: false,
                          "item-text": "name",
                          "item-value": "id",
                          chips: false,
                          "deletable-chips": "",
                        },
                        model: {
                          value: _vm.processWorksheet.processTypeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.processWorksheet, "processTypeId", $$v)
                          },
                          expression: "processWorksheet.processTypeId",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields.hasLocation
                    ? _c(VSelect, {
                        staticClass: "mx-2",
                        attrs: {
                          items: _vm.locations,
                          label: "Location",
                          multiple: false,
                          "item-text": "name",
                          "item-value": "id",
                          chips: false,
                          "deletable-chips": "",
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            _vm.generated = false
                          },
                        },
                        model: {
                          value: _vm.processWorksheet.locationId,
                          callback: function ($$v) {
                            _vm.$set(_vm.processWorksheet, "locationId", $$v)
                          },
                          expression: "processWorksheet.locationId",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields.hasProduct
                    ? _c("product-select", {
                        staticClass: "mx-2 mb-6",
                        attrs: { required: "" },
                        on: {
                          input: function ($event) {
                            _vm.generated = false
                          },
                        },
                        model: {
                          value: _vm.processWorksheet.productId,
                          callback: function ($$v) {
                            _vm.$set(_vm.processWorksheet, "productId", $$v)
                          },
                          expression: "processWorksheet.productId",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields.hasDeductibleWeight
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: { label: "Deductible Weight", required: false },
                        on: { change: _vm.deductibleWeightChanged },
                        model: {
                          value: _vm.processWorksheet.deductibleWeight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.processWorksheet,
                              "deductibleWeight",
                              $$v
                            )
                          },
                          expression: "processWorksheet.deductibleWeight",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields.hasTargetWeight
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: { label: "Target Weight", required: false },
                        model: {
                          value: _vm.processWorksheet.targetWeight,
                          callback: function ($$v) {
                            _vm.$set(_vm.processWorksheet, "targetWeight", $$v)
                          },
                          expression: "processWorksheet.targetWeight",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields.hasDocumentNumber
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: { label: "Document Number", required: false },
                        model: {
                          value: _vm.processWorksheet.documentNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.processWorksheet,
                              "documentNumber",
                              $$v
                            )
                          },
                          expression: "processWorksheet.documentNumber",
                        },
                      })
                    : _vm._e(),
                  _c("date-picker", {
                    attrs: {
                      label: "Process Time",
                      showTime: "",
                      defaultNowOnNull: false,
                      "show-hint": false,
                      "show-icon": false,
                    },
                    model: {
                      value: _vm.processWorksheet.processTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.processWorksheet, "processTime", $$v)
                      },
                      expression: "processWorksheet.processTime",
                    },
                  }),
                  _vm.worksheetTypeFields.hasMemo
                    ? _c(VTextarea, {
                        attrs: { label: "Memo", outlined: "" },
                        model: {
                          value: _vm.processWorksheet.memo,
                          callback: function ($$v) {
                            _vm.$set(_vm.processWorksheet, "memo", $$v)
                          },
                          expression: "processWorksheet.memo",
                        },
                      })
                    : _vm._e(),
                  _c(VTextarea, {
                    attrs: { label: "Worksheet Notes", outlined: "" },
                    model: {
                      value: _vm.processWorksheet.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.processWorksheet, "notes", $$v)
                      },
                      expression: "processWorksheet.notes",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "mt-4 d-flex justify-center" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.id ? "Update" : "Submit") + " "
                          ),
                        ]
                      ),
                      _c("span"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider, { staticClass: "my-6" }),
              _c(
                VSheet,
                { staticClass: "pa-4", attrs: { elevation: 2 } },
                [
                  _c(VSubheader, [_vm._v("Entries")]),
                  _vm._l(_vm.groupedEntries, function (entry, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "d-flex justify-space-between",
                      },
                      [
                        _c("div", { staticClass: "my-auto mr-2" }, [
                          _vm._v(_vm._s(index + 1) + "."),
                        ]),
                        _c(VTextField, {
                          staticClass: "mx-2",
                          attrs: {
                            label: "Gross Weight",
                            disabled: entry.inventoryUnitId,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.weightChanged(entry)
                            },
                          },
                          model: {
                            value: entry.grossWeight,
                            callback: function ($$v) {
                              _vm.$set(entry, "grossWeight", $$v)
                            },
                            expression: "entry.grossWeight",
                          },
                        }),
                        _c(VTextField, {
                          staticClass: "mx-2",
                          attrs: { label: "Net Weight", disabled: "" },
                          model: {
                            value: entry.netWeight,
                            callback: function ($$v) {
                              _vm.$set(entry, "netWeight", $$v)
                            },
                            expression: "entry.netWeight",
                          },
                        }),
                        _c("div", { staticClass: "mx-2 my-auto nowrap" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatDateTime")(entry.updateTime)
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "mx-2 my-auto" },
                          [
                            _c(
                              VIcon,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteEntry(index)
                                  },
                                },
                              },
                              [_vm._v("mdi-delete-outline")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "text-h6 text-center" }, [
                    _vm._v(
                      " Total Net Weight: " +
                        _vm._s(
                          _vm._f("formatNumber")(
                            _vm.totalWeight(_vm.processWorksheet.entries)
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-7",
                      attrs: {
                        disabled: _vm.processWorksheet.status == "SUBMITTED",
                      },
                      on: { click: _vm.addEntry },
                    },
                    [_vm._v("Add Measurement")]
                  ),
                  _vm.processWorksheet.status == "SUBMITTED"
                    ? _c("div", { staticClass: "text-caption ml-7 mt-2" }, [
                        _vm._v("Submitted worksheet is immutable"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }